import './App.css';
import DashboardPage from './pages/DashboardPage';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LeadsPage from './pages/LeadsPage';
import DealsPage from './pages/DealsPage';
// import TasksPage from './pages/TasksPage';
import AccountsPage from './pages/AccountsPage';
// import ContactsPage from './pages/ContactsPage';
// import CallsPage from './pages/CallsPage';
// import EmailsPage from './pages/EmailsPage';
import LeadDetailsPage from './pages/LeadDetailsPage';
import AccountDetailsPage from './pages/AccountDetailsPage';
import DealDetailsPage from './pages/DealDetailsPage';
// import RoleHierarchy from './components/RoleHierarcy';
// import DashboardBuilder from './components/DashboardBuilder';
// import ContactDetailsPage from './pages/ContactDetailsPage';
// import ProductsPage from './pages/ProductsPage';
import UsersPage from './pages/UsersPage';
// import ProductDetailsPage from './pages/ProductDetailsPage';
import UserDetailsPage from './pages/UserDetailsPage';
// import UserProfile from './components/UserProfile';
// import PermissionManagement from './components/PermissionManagement';
// import OwnerAnalytics from './components/OwnerAnalytics';
// import QuotationSystem from './pages/QuotationSystem';
// import Landing from './components/landing';
// import DepartmentsPage from './pages/DepartmentsPage';
import Login from './components/Login';
import ProtectedRoute from './components/protectedroute';
import PublicRoute from "./components/PublicRoute";
import AddDealSales from './components/AddDealSales';
import AddPurchase from './components/AddPurchase'
import SchedulePayment from './components/SchedulePayment'
import ManagePayment from './components/managepayment';
import ManageInvoice from './components/manageinvoice';
import ResetPassword from "./components/Resetpassword"; // adjust path to match where you saved it
import BidInformation from "./pages/BidInformation";
// inside your <Routes> ... </Routes>, alongside the existing "/" (Login) route:


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/dashboard" element={
          <ProtectedRoute>
          <DashboardPage />
          </ProtectedRoute>
          } />
        <Route path="/dashboard/:userId" element={
          <ProtectedRoute allowedRoles={['admin']}>
          <DashboardPage />
          </ProtectedRoute>
          } />
        <Route path="/leads" element={
          <ProtectedRoute allowedRoles={[
        "Admin",
        "Sales",
        "Presales",
        "Pre Sales",
        "Bid Manager",
        "BidManager",
      ]}>
            <LeadsPage/>
          </ProtectedRoute>
        } />
        <Route path="/deals" element={
          <ProtectedRoute allowedRoles={['sales', 'purchase', 'finance', 'admin']}>
            <DealsPage/>
          </ProtectedRoute>
        } />
        <Route path="/customers" element={
          <ProtectedRoute allowedRoles={['sales', 'admin']}>
            <AccountsPage/>
          </ProtectedRoute>
        } />
        <Route path="/leads/:id" element={
          <ProtectedRoute allowedRoles={['sales', 'admin']}>
            <LeadDetailsPage/>
          </ProtectedRoute>
        } />
        <Route
  path="/leads/:leadId/bid-information"
  element={
    <ProtectedRoute>
      <BidInformation />
    </ProtectedRoute>
  }
/>
        <Route path="/add_purchase/:opfId"  element={
          <ProtectedRoute allowedRoles={['purchase', 'admin']}>
            <AddPurchase/>
          </ProtectedRoute>
        } />
        <Route
  path="/schedule_payment/:purchase_id"
  element={
    <ProtectedRoute allowedRoles={['purchase','finance', 'admin']}>
      <SchedulePayment />
    </ProtectedRoute>
  }
/>
        <Route path="/customers/:id" element={
          <ProtectedRoute allowedRoles={['sales', 'admin']}>
            <AccountDetailsPage/>
          </ProtectedRoute>
        } />
        <Route path="/deals/:id" element={
          <ProtectedRoute allowedRoles={['sales', 'purchase', 'finance', 'admin']}>
            <DealDetailsPage/>
          </ProtectedRoute>
        } />

        <Route path="/users" element={
          <ProtectedRoute allowedRoles={['admin']}>
            <UsersPage/>
          </ProtectedRoute>
        } />
        <Route path="/users/:id" element={
          // <ProtectedRoute allowedRoles={['admin']}>
            <UserDetailsPage/>
          // </ProtectedRoute>
        } />
        {/* <Route path="/userprofile" element={<UserProfile/>}/> */}
        {/* <Route path="/permissions" element={<PermissionManagement/>} /> */}
        {/* <Route path="/owneranalytics" element={<OwnerAnalytics/>} />
        <Route path="/quotation" element={<QuotationSystem/>}/>
        <Route path="/landing" element={<Landing/>}/>
        <Route path="/departments" element={<DepartmentsPage/>}/> */}
        <Route path="/" element={
          <PublicRoute>
            <Login/>
          </PublicRoute>
         }
          />

          <Route path="/leads/:id/raise-opf" element={
            <ProtectedRoute allowedRoles={['sales', 'admin']}>
              <AddDealSales/>
            </ProtectedRoute>
          } />

          <Route
            path="/manage_payment/:opfId"
            element={
              <ProtectedRoute allowedRoles={['purchase','finance', 'admin']}>
                <ManagePayment/>
              </ProtectedRoute>
            }
          />

          <Route
            path="/manage_invoice/:opfId"
            element={
              <ProtectedRoute allowedRoles={['purchase','finance', 'admin']}>
                <ManageInvoice/>
              </ProtectedRoute>
            }
          />
          <Route path="/reset-password" element={<ResetPassword />} />
            <Route
  path="/unauthorized"
  element={
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f8fafc",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <h1 style={{ color: "#dc2626" }}>Unauthorized Access</h1>

        <p style={{ color: "#64748b" }}>
          You do not have permission to access this page.
        </p>
      </div>
    </div>
  }
/>

      </Routes>
    </Router>
  );
}

export default App;